export const ATUALIZAR_NOTA = 'ATUALIZAR_NOTA';
export const atualizarNota = (nota) => ({
  type: ATUALIZAR_NOTA,
  payload: {
    nota,
  },
});
export const SELECT_NOTA = 'SELECT_NOTA';
export const selectNota = (selectNota) => ({
  type: SELECT_NOTA,
  payload: {
    selectNota,
  },
});



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/notas/notas.action.js